class MegaMenuCustom extends HTMLElement {
  constructor() {
    super();

    this.level2Groups = this.querySelectorAll('.level-2 > ul');
    this.level3Groups = this.querySelectorAll('.level-3 > ul');
  }

  connectedCallback() {
    this.addEventListener('mouseover', (e) => {
      const target = e.target.closest('li');
      if (!target) return;

      if (target.closest('.level-1')) {
        this.showLevel2(target.dataset.id);
      } else if (target.closest('.level-2')) {
        this.showLevel3(target.dataset.id);
      }
    });

    this.addEventListener('mouseleave', () => {
      this.level2Groups.forEach(group => group.classList.remove('is-visible'));
      this.level3Groups.forEach(group => group.classList.remove('is-visible'));
    });
  }

  showLevel2(id) {
    this.level2Groups.forEach(group =>
      group.classList.toggle('is-visible', group.dataset.parent === id)
    );
    this.level3Groups.forEach(group => group.classList.remove('is-visible'));
  }

  showLevel3(id) {
    this.level3Groups.forEach(group =>
      group.classList.toggle('is-visible', group.dataset.parent === id)
    );
  }
}

customElements.define('mega-menu-custom', MegaMenuCustom);
